import { Injectable, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { Statique } from '../utils/statique';
import { AuthHttp, JwtHelper } from "angular2-jwt";
import { tokenNotExpired } from 'angular2-jwt';
import { BehaviorSubject, Subject } from 'rxjs';
import { EbUser } from '../classes/user';
import { TOKEN_NAME } from './auth.constant';
import { Observable } from 'rxjs/Observable';
import { EbEtablissement } from '../classes/etablissement';

@Injectable()
export class AuthenticationService implements OnInit {


  connectedUser = new Subject();
  private notifySideBar = new Subject<any>();
  sideBarInitUserObservale = this.notifySideBar.asObservable();

  set theConnectedUser(value) {
    this.connectedUser.next(value); // this will make sure to tell every subscriber about the change.
    localStorage.setItem(TOKEN_NAME, value);
  }

  public notifySideBarInitUser() {
      this.notifySideBar.next();
  }

  get theConnectedUser() {
    return localStorage.getItem(TOKEN_NAME);
  }

  ngOnInit(): void {

  }

  /*private loggedInObservable = new BehaviorSubject<boolean>(false);

  get isLoggedInObservable()
  {
   return  new Observable<boolean>( observer => {
      observer.next ( AuthenticationService.isAuthenticated ());
    });

  }*/

  constructor(private http: Http) {
  }



  jwtHelper: JwtHelper = new JwtHelper();
  /**
   * Cette fonction est responsable de l'authentification. C'est elle qui envoit  le login et le mot de  passe au backend.
   * Le backend  genere et retourne un tocken en cas de succès
   * @param username
   * @param password
   */
  login(username: string, password: string, emailCt: string = null, passwordCt: string = null, isControlTower: boolean = false) {
    let self = this;
    let uri = Statique.AUTH_TOKEN
    let body = {}

    body = {
      username : username,
      password : password,
    }
   // let body = `?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`;
    if(emailCt && passwordCt)
      body = {
        username : username,
        password : password,
        usernamect : emailCt,
        passwordct : passwordCt,
      }
    //  body += `&usernamect=${encodeURIComponent(emailCt)}&passwordct=${encodeURIComponent(passwordCt)}`;
    if(isControlTower)
      uri += `?ct=${isControlTower}`;

    const headers = new Headers();
    return this.http.post(uri, body, { headers })
      .map(res => {
        let accessToken: string = res.text();

        self.theConnectedUser = accessToken;
        //this.itemValue.next(true);
        return accessToken;

      });
  }

  logout() {
    let self = this;
    //this.accessToken = null;
    //this.isAdmin = false;
    self.theConnectedUser = null;
  }

  loggedIn() {
    return AuthenticationService.getConnectedUser() != null;
  }

  static isAuthenticated(): boolean {
    let user = AuthenticationService.getConnectedUser();
    if (user != null) {
      return true;
    }
    return false;
  }



  static getConnectedUser(): EbUser {
    const token = localStorage.getItem(TOKEN_NAME);
    let userConnected: EbUser = this.decodeTocken(token);
    return userConnected;
  }


  static decodeTocken(tockenStr): EbUser {
    let jwtHelper: JwtHelper = new JwtHelper();
    if (tockenStr != null && tockenStr != "" && tockenStr.indexOf(".") > 0) {
      const decodedToken = jwtHelper.decodeToken(tockenStr);
      if (decodedToken.authorities != null) {
        if (!decodedToken.connectedUserKey)
          decodedToken.connectedUserKey = decodedToken.user;
        if (decodedToken.connectedUserKey)
          decodedToken.connectedUserKey.authorities = decodedToken.authorities;
      }

      return decodedToken.connectedUserKey;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts